/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import {Component, Inject} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material/dialog';
import {FabMessageService} from '@fabric/components/message';

@Component({
    selector: 'app-info-pop-up',
    templateUrl: './info-pop-up.component.html',
    styleUrls: ['./info-pop-up.component.scss'],
    standalone: false
})
export class InfoPopUpComponent {
  title = 'Title';
  info = '';

  constructor(@Inject(MAT_DIALOG_DATA) private readonly data: any,
              public dialogRef: MatDialogRef<InfoPopUpComponent>,
              public snackBar: FabMessageService) {
    if (data) {
      if (!data.info) {
        this.dialogRef.close();
      }
      this.title = data.title;
      this.info = data.info;
    }
  }


}
